// Loader.js
import React from "react";
import Lottie from "react-lottie";
import animationData from "../utils/loading.json"; // adjust the path as needed

const AnimatedLoader = ({ isLoading }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  if (!isLoading) {
    return null;
  }

  return (
    <div className="loader-container">
      <Lottie options={defaultOptions} height={150} width={150} />
    </div>
  );
};

export default AnimatedLoader;
